/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2019-08-20 16:56:41
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-03-23 19:20:21
 */
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 自定义的全局组件
import contentLayer from './base/contentLayer' // 弹框插件
import formContent from './base/form' // 表单插件
import tableContent from './base/table' // 表格插件
import buttonContent from './base/button' // 按钮插件
import page from './base/page' // 分页插件
import { getTitleDes } from 'common/js/formDes/util.js'
import { API } from 'api/index.js'
import CryptoJS from 'api/crypto'
import { prefixUrl } from 'api/config.js' // 接口前缀(区分 发开/测试/生产)
import { Loading } from 'element-ui';
import {hostManage} from 'api/config.js'
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$getTitleDes = getTitleDes;
Vue.prototype.$apiData = API;
Vue.prototype.Loading = Loading;
Vue.prototype.$prefixUrl = prefixUrl
Vue.prototype.$host = hostManage
Vue.use(contentLayer)
Vue.use(formContent)
Vue.use(tableContent)
Vue.use(page)
Vue.use(buttonContent)

// AES加解密
Vue.crypto = Vue.prototype.$crypto = CryptoJS


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js